import { Component, DestroyRef, signal } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { Router, RouterModule } from '@angular/router';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { UserHttpService } from '../../core/services/user.http.service';
import { ToastService } from '../../core/services/toast.service';

@Component({
  selector: 'app-otp',
  imports: [RouterModule, MatCardModule, MatButtonModule],
  templateUrl: './otp.html',
  styleUrl: './otp.scss',
})
export class Otp {
  readonly isSubmitting = signal<boolean>(false);
  readonly errorMessage = signal<string>('');
  readonly successMessage = signal<string>('');

  constructor(
    private httpService: UserHttpService,
    private destroyRef: DestroyRef,
    private router: Router,
    private toast: ToastService,
  ) { }

  onRequestOtp(): void {
    if (this.isSubmitting()) {
      return;
    }

    this.isSubmitting.set(true);
    this.errorMessage.set('');
    this.successMessage.set('');

    this.httpService.requestOtp().pipe(takeUntilDestroyed(this.destroyRef)).subscribe({
      next: (res) => {
        this.isSubmitting.set(false);
        const message = String(res?.message ?? 'OTP code has been sent to your email.');
        this.successMessage.set(message);
        this.toast.success(message);
        this.router.navigate(['/dashboard']);
      },
      error: (error) => {
        this.isSubmitting.set(false);
        const apiMessage = String(error?.error?.message ?? '').trim();
        const message = apiMessage || 'Failed to request OTP. Please login and try again.';
        this.errorMessage.set(message);
        this.toast.error(message);
      },
    });
  }
}
